import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.383 4.844a.75.75 0 01.935-.5 8 8 0 01-3.765 15.524.75.75 0 01.271-1.475 6.5 6.5 0 003.06-12.614.75.75 0 01-.501-.935zM10.723 4.824a.75.75 0 01-.514.928 6.5 6.5 0 00-2.544 11.091.75.75 0 01-1 1.118A8 8 0 019.794 4.31a.75.75 0 01.928.514z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.842 6.88a5.25 5.25 0 016.276 6.292.75.75 0 11-1.463-.335 3.75 3.75 0 10-2.041 2.548.75.75 0 01.645 1.354 5.25 5.25 0 11-3.417-9.86z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M12.297 11.045a1 1 0 00-.986.23.75.75 0 01-1.033-1.087 2.5 2.5 0 11.875 4.164.75.75 0 11.508-1.411 1 1 0 10.636-1.896z",
      "clip-rule": "evenodd"
    })
  ]))
}